import React from 'react';
import DispatchContainer from '../../components/AdminNext/DispatchContainer';
import HeadLessLayout from '../../components/Layout/HeadLessLayout';

/*
 * Kerangka dashboard baru.
 *
 * Belum ada layar di dalamnya — halaman ini SENGAJA cuma navigasi. Gunanya
 * memberi client struktur baru yang bisa diklik sejak sekarang, sementara tiap
 * item masih membuka layar lama di /siteadmin.
 *
 * HeadLessLayout, bukan AdminLayout: AdminLayout membawa header, SideMenu dan
 * CSS dashboard lama, yang justru sedang digantikan.
 */
function action({ store }) {
  const isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;

  /*
   * Cek login saja, TANPA restrictUrls — persis seperti route dashboard lama
   * di site-admin/dashboard. `/siteadmin` sendiri tidak terdaftar di tabel
   * PrivilegesLink, jadi restrictUrls('/siteadmin') selalu false dan setiap
   * admin akan dipantulkan keluar. Halaman ini juga tidak menampilkan data
   * apa pun; tiap item sidebar tetap tunduk pada hak akses layar tujuannya.
   */
  if (!isAdminAuthenticated) return { redirect: '/login' };

  return {
    title: 'Dispatch — Bas Recovery Admin',
    component: (
      <HeadLessLayout>
        <DispatchContainer />
      </HeadLessLayout>
    )
  };
}

export default action;
